module.exports = __webpack_public_path__ + "static/media/tennis-ball.ad1a11f5.svg";